import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [message, setMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    const usernameCookie = document.cookie.split('; ').find(row => row.startsWith('username='));
    if (token || usernameCookie) {
      navigate("/Home");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    if (!formData.username || !formData.password) {
      setMessage("Missing username or password");
      return;
    }
    try {
      const response = await fetch("/login?", {
        method: "POST", 
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem("token", data.token);
        document.cookie = `name=${encodeURIComponent(data.name)}; path=/`;
        document.cookie = `username=${encodeURIComponent(data.username)}; path=/`;

        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          navigate("/Home");
        }, 3000);
      } else {
        setMessage(data.message || "Login failed");
      }
    } catch (error) {
      setMessage("Error connecting to server");
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f0f2f5',
      padding: '20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '400px',
        boxSizing: 'border-box'
      }}>
        <h2 style={{
          marginBottom: '24px',
          fontWeight: '600',
          fontSize: '28px',
          color: '#333',
          textAlign: 'center'
        }}>Login</h2>
        {message && <p style={{
          color: 'red',
          marginBottom: '16px',
          textAlign: 'center'
        }}>{message}</p>}
        {showToast && <div style={{
          backgroundColor: '#4BB543',
          color: 'white',
          padding: '12px 20px',
          borderRadius: '8px',
          textAlign: 'center',
          marginBottom: '16px',
          fontWeight: '500',
          boxShadow: '0 4px 12px rgba(75, 181, 67, 0.4)'
        }}>Login successful!</div>}
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '500', color: '#555' }}>
            Username:
            <input
              type="text"
              name="username"
              required
              value={formData.username}
              onChange={(e) => setFormData({ ...formData, username: e.target.value })}
              style={{
                marginTop: '8px',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #ccc',
                fontSize: '16px',
                transition: 'border-color 0.3s',
                outline: 'none'
              }}
              onFocus={(e) => e.target.style.borderColor = '#667eea'}
              onBlur={(e) => e.target.style.borderColor = '#ccc'}
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', fontWeight: '500', color: '#555' }}>
            Password:
            <input
              type="password"
              name="password"
              required
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              style={{
                marginTop: '8px',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #ccc',
                fontSize: '16px',
                transition: 'border-color 0.3s',
                outline: 'none'
              }}
              onFocus={(e) => e.target.style.borderColor = '#667eea'}
              onBlur={(e) => e.target.style.borderColor = '#ccc'}
            />
          </label>
          <button type="submit" style={{
            backgroundColor: '#667eea',
            color: 'white',
            padding: '14px',
            borderRadius: '8px',
            border: 'none',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.3s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#556cd6'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#667eea'}
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
